import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import AccountSetPassword from './../AccountSetPassword'
import i18next from 'i18next'
import Loading from './../Loading'

import * as accountActions from '../../ducks/account'

class ResetPasswordContainer extends React.Component {
  componentDidMount() {
    this.props.actions.isPasswordResetTokenValid(this.props.params.token)
  }

  render() {
    if (this.props.isPasswordResetTokenValid === null) {
      return <Loading />
    }

    const onResetPassword = password => {
      this.props.actions.resetPassword(this.props.params.token, password)
    }

    return (
      <AccountSetPassword
        showAccount={false}
        isLinkValid={this.props.isPasswordResetTokenValid}
        title={i18next.t('reset_password')}
        buttonText={i18next.t('set_password')}
        onSetPassword={onResetPassword}
      />
    )
  }
}

function mapStateToProps(state) {
  return {
    isPasswordResetTokenValid: state.account.get('isPasswordResetTokenValid')
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(accountActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordContainer)



// WEBPACK FOOTER //
// ./src/components/smart/ResetPasswordContainer.js